const PbxxRecord = require('../pbxx_record')

module.exports = class FacebookAccount extends PbxxRecord {
  static get class_name() {
    return 'FacebookAccount'
  }
}
